/**
 * Envolve um valor em `url("...")` para uso em CSS-in-JS (styled-components).
 *
 * Por quê isso existe: SVGs importados pelo Vite viram data URIs com aspas simples cruas
 * nos atributos (ex.: `data:image/svg+xml,%3csvg width='8'...`). Um `url("${icon}")` escrito
 * direto no template CSS funciona em runtime, mas o Prettier reformata as aspas dentro do
 * template (CSS-in-JS embutido) para o padrão `singleQuote` do projeto — reescrevendo pra
 * `url('${icon}')` e reintroduzindo o bug (o tokenizer do stylis se confunde com aspas
 * simples aninhadas e descarta a declaração inteira). Produzindo a string via função, as
 * aspas nunca aparecem como texto literal no CSS do template — não há nada pro Prettier
 * "corrigir" — e o fix sobrevive a qualquer `yarn format` futuro.
 */
export const cssUrl = (path: string): string => `url("${path}")`;
